import { themeQuartz } from "ag-grid-community";
import {
  BASE_API_AUTH_URL,
  BASE_API_DELIVERY,
  BASE_API_Log,
  BASE_API_MDM,
  BASE_API_POS,
  BASE_API_PAYMENT,
  BASE_API_AP,
  BASE_API_CART,
  API_WEB_OLD,
  WEB_APP_API_URL,
  API_WEB_CLIENT,
} from "../../config";
import Repository from "../helper/HttpHelper";
import { modals } from "@mantine/modals";
import React from "react";
import { BackgroundColor } from "@tiptap/extension-text-style";

export const _timerDelayClick: number = 3;
export const _timerDelaySearch: number = 1;
export const repositoryMaster = new Repository(BASE_API_AUTH_URL);
export const repositoryPos = new Repository(BASE_API_POS);
export const repositoryCart = new Repository(BASE_API_CART);
export const repositoryMdm = new Repository(BASE_API_MDM);
export const repositoryAp = new Repository(BASE_API_AP);
export const repositoryLog = new Repository(BASE_API_Log);
export const repositoryDelivery = new Repository(BASE_API_DELIVERY);
export const repositoryPayment = new Repository(BASE_API_PAYMENT);
export const repositoryWebOld = new Repository(API_WEB_OLD);
export const repositoryWeb = new Repository(WEB_APP_API_URL);
export const repositoryWebClient = new Repository(API_WEB_CLIENT);

export const pagination = true;
export const paginationPageSize = 25;
export const paginationPageSizeSelector = [25, 50, 100];

export const dataExchangeRate = [
  {
    calculation: "Tiền mặt VND tại CN",
    currencyType: "VND",
    value: 1,
    id: 111101,
  },
  {
    calculation: "Tiền mặt ngoại tệ tại Cty",
    currencyType: "USD",
    value: 24200,
    id: 111210,
  },
  {
    calculation: "Vàng bạc, kim khí quý, đá quý",
    currencyType: "GOLD",
    value: 7800000,
    id: 111301,
  },
];

export const RequiedCompont = ({ title }: { title: string }) => {
  return (
    <>
      <span>
        {title} <span style={{ color: "red" }}>(*)</span>
      </span>
    </>
  );
};

export const baseTheme = themeQuartz.withParams({
  fontSize: 12,
  headerFontSize: 14,
  spacing: 5,
});

export const openModalSave = (
  title: string,
  message: React.ReactNode,
  onSave: Promise<void> | void,
) =>
  modals.openConfirmModal({
    title: title,
    children: message,
    labels: { confirm: "Lưu", cancel: "Hủy bỏ" },
    onCancel: () => console.log("Cancel"),
    onConfirm: async () => onSave,
  });

export const styleTableMantine = {
  fontWeight: 550, //conditional styling
  fontSize: "11.5px",
  padding: "6px 8px",
};
export const styleTableMantineExpress = {
  fontWeight: 550, // conditional styling
  fontSize: "11.5px",
  padding: "6px 8px",
};
export const keySearchProfitRevenueCTKM = "keySearchProfitRevenueCTKM";
export const keySearchSPLU = "keySearchSPLU";
export const keySearchApproveApplicationList =
  "keySearchApproveApplicationList";
export const keySearchSalesReportByProduct = "keySearchSalesReportByProduct";
export const keySearchMIIR = "keySearchMIIR";
export const keySearchSalesOrderListInstallment =
  "keySearchSalesOrderListInstallment";
export const keySearchPurchaseRegistrationList =
  "keySearchPurchaseRegistrationList";
export const keySearchListTMDTv2 = "keySearchListTMDTv2";
export const keySearchSalesOrderListOpproval =
  "keySearchSalesOrderListOpproval";
export const keySearchWriteVAT = "keySearchWriteVAT";
export const keySearchVATManager = "keySearchVATManager";
export const keySearchBankingTransactions = "keySearchBankingTransactions";
export const keySearchListTMDT = "keySearchListTMDT";
export const keySearchCompareSaleOrderWeb = "keySearchCompareSaleOrderWeb";
export const keySearchSalesOrderListWebsite = "keySearchSalesOrderListWebsite";
export const keySearchSalesOrderListV2 = "keySearchSalesOrderListV2";
export const keySearchListOrderTMDTV2 = "keySearchListOrderTMDTV2";
export const keySearchListTMDTV2 = "keySearchListTMDTV2";
export const keySearchSalesOrderListNoAddressCus =
  "keySearchSalesOrderListNoAddressCus";
export const keySearchwip = "keySearchwip";

export const keySearchSalesOrderListOnlyRead =
  "keySearchSalesOrderListOnlyRead";
export const keySearchWarehouseOutWard = "keySearchWarehouseOutWard";
export const keySearchWaRerequestTransfer = "keySearchWaRerequestTransfer";
export const keySearchWaRerequestTransferInternal =
  "keySearchWaRerequestTransferInternal";
export const keySearchWarehouseOutWardList = "keySearchWarehouseOutWardList";
export const keySearchWarehouseInWardList = "keySearchWarehouseInWardList";
export const keySearchRequestInventoryTransaction =
  "keySearchRequestInventoryTransaction";
export const keySearchRequestListReceipts = "keySearchRequestListReceipts";
export const KeySearchTestingTechnique = "KeySearchTestingTechnique";
export const keySearchReportSaleOrder = "keySearchReportSaleOrder"; //Báo cáo doanh số bán hàng
export const keySearchGeneralSalesStatement = "keySearchGeneralSalesStatement"; //Báo cáo bán hàng theo ngày
export const keySearchReportDepartment = "keySearchReportDepartment"; //Báo cáo bán hàng theo ngày
export const keySearchSalesBarcode = "keySearchSalesBarcode"; //Báo cáo bán hàng theo mã vạch
export const keySearchCompareOrder = "keySearchCompareOrder";
export const keySearchCompareTBC = "keySearchCompareTBC";
export const keySearchCompareInv = "keySearchCompareInv";
export const keySearchCompareVT = "keySearchCompareVT";
export const keySearchCompareInventory = "keySearchCompareInventory";
export const keySearchDeliveryDispatch = "keySearchDeliveryDispatch";
export const keySearchReceptionList = "keySearchReceptionList";
export const keySearchRerequestManagerTransfer =
  "keySearchRerequestManagerTransfer";

export const typeGv = [
  { value: "1", label: "NV điều vận" },
  { value: "2", label: "Kỹ thuật" },
  { value: "3", label: "Dự án" },
  { value: "4", label: "Kỹ thuật thi công" },
  { value: "5", label: "Tất cả (Chỉ sử dụng để xem đơn)" },
];

export const LoaiGv = [
  { value: "NV điều vận", label: "NV điều vận" },
  { value: "Kỹ thuật", label: "Kỹ thuật" },
  { value: "Dự án", label: "Dự án" },
  { value: "Kỹ thuật thi công", label: "Kỹ thuật thi công" },
];
